import { PipeTransform, Pipe } from '@angular/core';
import { Item } from '../_interface/item';

@Pipe({
    name: 'unitsFilter'
})
export class UnitsFilterPipe implements PipeTransform {
    transform(units: any, searchTerm: string): Item[] {
        if (!units || !searchTerm) {
            return units;
        }

        return units.filter(unit => {
            if (unit.number != null) {  // Ensure unit.number is not null or undefined
              let unitNumForCompare = unit.number.toString();  // Convert to string
              return unitNumForCompare.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) !== -1;
            }
            return false;  // Filter out units without a number
          });

        // if (units.number.toLocaleLowerCase() === searchTerm.toLocaleLowerCase()){
        //     return units;
        // }
        // units.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) !== -1);

    }
}